import { render } from "./AnnotationReview.vue?vue&type=template&id=6217ba48&scoped=true"
import script from "./AnnotationReview.vue?vue&type=script&lang=js"
export * from "./AnnotationReview.vue?vue&type=script&lang=js"

import "./AnnotationReview.vue?vue&type=style&index=0&id=6217ba48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6217ba48"]])

export default __exports__